import { render } from "./ModalMedPrice.vue?vue&type=template&id=4f2b9227"
import script from "./ModalMedPrice.vue?vue&type=script&lang=js"
export * from "./ModalMedPrice.vue?vue&type=script&lang=js"

import "./ModalMedPrice.vue?vue&type=style&index=0&id=4f2b9227&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__